import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ButtonProps, Dialog } from '@optimus-web/core';
import { getResourceCategoryName } from '@mews-commander/legacy-entities/src/ducks/resourceCategories';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { getTimelineAvailabilityDialogProps, isAssigningResource } from '../reducers';
import { assignResource, closeAvailabilityDialog } from '../actions';

export const AvailabilityWarningDialog = () => {
    const props = useCommanderSelector(getTimelineAvailabilityDialogProps);
    const isAssigningResourceLoading = useCommanderSelector(isAssigningResource);

    const dispatch = useCommanderThunkDispatch();
    const closeDialog = () => dispatch(closeAvailabilityDialog());
    const handleSubmit = async () =>
        props &&
        dispatch(
            assignResource({
                resourceUseId: props.reservationId,
                resourceId: props.resourceId,
                checkAvailability: false,
                updateBlockAvailability: true,
            })
        ).then(closeDialog);

    const actions: ButtonProps[] = [
        {
            children: <LocalizedText textKey={TextKey.GoBack} />,
            onClick: closeDialog,
            variant: 'ghost',
            type: 'submit',
        },
        {
            children: <LocalizedText textKey={TextKey.Save} />,
            onClick: handleSubmit,
            variant: 'primary',
            type: 'submit',
        },
    ];
    const newResourceCategoryName =
        useCommanderSelector(
            (s) =>
                props?.selectedCategoryId &&
                getResourceCategoryName(s, { id: props.selectedCategoryId, serviceId: props.serviceId })
        ) ?? '';

    const oldResourceCategoryName =
        useCommanderSelector(
            (s) =>
                props?.assignedCategoryId &&
                getResourceCategoryName(s, { id: props.assignedCategoryId, serviceId: props.serviceId })
        ) ?? '';

    return (
        <Dialog
            actions={actions}
            active={!!props}
            loading={isAssigningResourceLoading}
            title={
                <LocalizedText
                    textKey={TextKey.ResourceCategoryNotInAvailabilityBlockTitle}
                    substitutes={{ resourceCategoryName: newResourceCategoryName }}
                />
            }
            onClose={closeDialog}
        >
            <LocalizedText
                textKey={TextKey.ResourceCategoryNotInAvailabilityBlockMessage}
                substitutes={{ oldResourceCategoryName, newResourceCategoryName }}
            />
        </Dialog>
    );
};
